export default "__VITE_ASSET__DMllnR79__"